import {createReducer} from '@reduxjs/toolkit';
import {resetFilters, setFilter} from '../../actions/search.js';
import {trackEvent} from '../../analytics.js';

const defaultState = {
  cloud_cover: [0, 0.2],
  view_angle: [-60, 60],
  gsd: [0.1, 30],
  sun_azimuth: [0, 360],
  sun_elevation: [0, 90],
};

export default createReducer(defaultState, builder => {
  builder.addCase(setFilter, (state, {payload}) => {
    trackEvent('Modified Filter', {
      ...payload,
    });
    state[payload.key] = payload.value;
  });
  builder.addCase(resetFilters, () => defaultState);
});
